/* SET STATE */
export const SET_STATE_INTERNALSAMPLE = "SET_STATE_INTERNALSAMPLE"

/* INTERNALSAMPLES */
export const GET_INTERNALSAMPLES = "GET_INTERNALSAMPLES"
export const GET_INTERNALSAMPLES_SUCCESS = "GET_INTERNALSAMPLES_SUCCESS"
export const GET_INTERNALSAMPLES_FAIL = "GET_INTERNALSAMPLES_FAIL"

/* INTERNALSAMPLE */
export const GET_INTERNALSAMPLE = "GET_INTERNALSAMPLE"
export const GET_INTERNALSAMPLE_SUCCESS = "GET_INTERNALSAMPLE_SUCCESS"
export const GET_INTERNALSAMPLE_FAIL = "GET_INTERNALSAMPLE_FAIL"

/**
 * ADD INTERNALSAMPLE
 */
 export const ADD_NEW_INTERNALSAMPLE = "ADD_NEW_INTERNALSAMPLE"
 export const ADD_INTERNALSAMPLE_SUCCESS = "ADD_INTERNALSAMPLE_SUCCESS"
 export const ADD_INTERNALSAMPLE_FAIL = "ADD_INTERNALSAMPLE_FAIL"

 /**
 * UPDATE INTERNALSAMPLE
 */
export const UPDATE_INTERNALSAMPLE = "UPDATE_INTERNALSAMPLE"
export const UPDATE_INTERNALSAMPLE_STATUS = "UPDATE_INTERNALSAMPLE_STATUS"
export const UPDATE_INTERNALSAMPLE_SUCCESS = "UPDATE_INTERNALSAMPLE_SUCCESS"
export const UPDATE_INTERNALSAMPLE_FAIL = "UPDATE_INTERNALSAMPLE_FAIL"

/**
 * DELETE INTERNALSAMPLE
 */
export const DELETE_INTERNALSAMPLE = "DELETE_INTERNALSAMPLE"
export const DELETE_INTERNALSAMPLE_SUCCESS = "DELETE_INTERNALSAMPLE_SUCCESS"
export const DELETE_INTERNALSAMPLE_FAIL = "DELETE_INTERNALSAMPLE_FAIL"
